import { createTRPCReact } from "@trpc/react-query";
import { httpBatchLink } from "@trpc/client";
import superjson from "superjson";
import type { AppRouter } from "../../../server/routers/_index";

export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: "/api/trpc",
      transformer: superjson,
      // Pass session cookies + Cf-Access headers through automatically.
      // Also forward a bootstrap admin token from localStorage (used by
      // /admin/playbook etc. until Cf-Access is configured for the zone).
      fetch(url, opts) {
        const tok = typeof window !== "undefined" ? localStorage.getItem("admin_bootstrap_token") : null;
        const headers = new Headers((opts as RequestInit)?.headers ?? {});
        if (tok) headers.set("X-Admin-Bootstrap", tok);
        return fetch(url, { ...opts, credentials: "include", headers });
      },
    }),
  ],
});
